exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "ul li[data-v-4c8f8d7c]{padding:15px 0;border-bottom:1px dashed #e4e4e4;display:-ms-flexbox;display:flex}ul li[data-v-4c8f8d7c]:last-child{border-bottom:none}ul li label[data-v-4c8f8d7c]{font-size:12px;line-height:1.6}ul li label[data-v-4c8f8d7c]:first-child{width:4.5rem;text-align:right;margin-right:5px;-ms-flex-negative:0;flex-shrink:0;color:#989898}ul li .el-tag[data-v-4c8f8d7c]{margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c8f8d7c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/License.vue
// module id = 399
// module chunks = 1